import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: () => import("../views/home/home.vue"),
    },
    {
        path: "/downInfo",
        name: "downInfo",
        component: () => import("../views/service_support/downInfo.vue"),
    },
    {
        path: "/serviceSupportDetail",
        name: "serviceSupportDetail",
        component: () => import("../views/service_support/service_support_detail.vue"),
    },
    {
        path: "/adaptationCert",
        name: "adaptationCert",
        component: () => import("../views/adaptationCert/index.vue"),
    },
    {
        path: "/AISmartManagement",
        name: "AISmartManagement",
        component: () => import("../views/AISmartManagement/index.vue"),
    },
    {
        path: "/appointmentService",
        name: "appointmentService",
        component: () => import("../views/appointmentService/index.vue"),
    },
    {
        path: "/humanResources",
        name: "humanResources",
        component: () => import("../views/humanResources/index.vue"),
    },
    {
        path: "/supplyChain",
        name: "supplyChain",
        component: () => import("../views/supplyChain/index.vue"),
    },
    {
        path: "/equipAssets",
        name: "equipAssets",
        component: () => import("../views/equipAssets/index.vue"),
    },
    {
        path: "/finance",
        name: "finance",
        component: () => import("../views/finance/index.vue"),
    },
    {
        path: "/bascm",
        name: "bascm",
        component: () => import("../views/bascm/index.vue"),
    },
    {
        path: "/Overall",
        name: "Overall",
        component: () => import("../views/Performance/Overall.vue"),
    },
    {
        path: "/department",
        name: "department",
        component: () => import("../views/cost/department.vue"),
    },
    {
        path: "/hprSystem",
        name: "hpr_system",
        component: () => import("../views/product/hpr_system.vue"),
    },
    {
        path: "/odrSystem",
        name: "odr_system",
        component: () => import("../views/product/odr_system.vue"),
    },
    {
        path: "/singleHospital",
        name: "single_hospital",
        component: () =>
            import("../views/solution/single_hospital.vue"),
    },
    {
        path: "/medicalCommunityManagement",
        name: "medicalCommunityManagement",
        component: () =>
            import("../views/solution/medical_community_management.vue"),
    },
    {
        path: "/medicalGroupManager",
        name: "medical_group_manager",
        component: () => import("../views/solution/medical_group_manager.vue"),
    },
    {
        path: "/medicalGroupSanitation",
        name: "medical_group_sanitation",
        component: () => import("../views/solution/medical_group_sanitation.vue"),
    },
    {
        path: "/customerCase",
        name: "customerCase",
        component: () => import("../views/customer_case/customer_case.vue"),
    },
    {
        path: "/partner",
        name: "partner",
        component: () => import("../views/partner/partner.vue"),
    },
    {
        path: "/serviceSupport",
        name: "serviceSupport",
        component: () => import("../views/service_support/service_support.vue"),
    },
    {
        path: "/company",
        name: "company",
        component: () => import("../views/about/company.vue"),
    },
    {
        path: "/branch",
        name: "branch",
        component: () => import("../views/about/branch.vue"),
    },
    {
        path: "/qualificationHonor",
        name: "qualification_honor",
        component: () => import("../views/about/qualification_honor.vue"),
    },
    {
        path: "/viewpointsAdvantages",
        name: "viewpoints_advantages",
        component: () => import("../views/about/viewpoints_advantages.vue"),
    },
    {
        path: "/newsInformation",
        name: "news_information",
        component: () => import("../views/about/news_information.vue"),
    },
    {
        path: "/news_information_detail",
        name: "news_information_detail",
        component: () => import("../views/about/news_information_detail.vue"),
    },
    {
        path: "/job",
        name: "job",
        component: () => import("../views/about/job.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, form, next) => {
    if (to.query.name) {
        sessionStorage.setItem("routeQuery", to.query.name);
    }
    if (to.query.activeSubTitle) {
        sessionStorage.setItem("activeSubTitle", to.query.activeSubTitle);
    }
    // sessionStorage.setItem("activePath", to.path);
    next();
});

export default router;
